import { Injectable, Inject } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { DataColumn, AppinfoService, GeneralColType } from './appinfo.service';
import { AttrIndexService } from './attr-index.service';
import { CommonModalService } from './common-modal.service';
import { ConfirmModalData, ConfirmModalComponent } from 'app/components/modal/confirm-modal/confirm-modal.component';
import { ColumnFilter } from './gfo.service';
import { GtoProperty, Gto, GtoService } from './gto.service';
import { UserService } from './user.service';
import { LRSMap } from 'assets/TS/LRSMap_New';

import { Fill, RegularShape, Stroke, Style, Text, Icon, Circle } from 'ol/style';
import { GivColumnDomain } from './domain.service';
import { ToastrService } from 'ngx-toastr';
import { LayerQcService, QcEditFilter } from './layer-qc.service';
import { ActivityService } from './activity.service';
import { BehaviorSubject } from 'rxjs';
import { UnsavedChangesWarningComponent } from 'app/components/modal/unsaved-changes-warning/unsaved-changes-warning.component';
import { MatDialogConfig } from '@angular/material';

export interface BoundaryFeatProp {
	cusId: number;
	stateName: string
}

export interface CardSelectedRecord {
	recId: any;
	source: 'card' | 'notCard';
	updateTableMap?: boolean;
}

export interface JsonbInfo {
	[jsonbColName: string]: string[];
}

// Edit Card Components Use
export interface EditCardColumn {
	prop: string;
	name: string;
	info: {
		// Editing attrs
		hideFromEditing?: boolean;
		isEditDisabled?: boolean;
		domain?: GivColumnDomain;
		neighborList?: string[]; // store neighbor county/state
		tooltip?: string;
		standardColName?: string;
		isUppercase?: boolean;
		isFishbone?: boolean;
	};
	isDisplay?: boolean; // If false, do not display column; If not defined or any other value, display column

	isAnchored?: boolean;
	mouseoverAnchor?: boolean;
}

export type LeaveWarningResponse = 'discard' | 'commit' | false;

@Injectable({
	providedIn: 'root'
})
export class EditService {

	// editRecordList: any[] = [];
	// editRecordListHidden: any[] = []; // Hidden from displaying in cards // 1. can stores the neighbor features that has changed during topo fix // 2. can store deleted feature (not the normal ones deleted by user, but features like: when doing splits in centerline editing, the splited feature will be deleted)

	// public readonly dmBackgroundLayerName = 'dmBackgroundLayer';
	//
	public readonly dataLayerName = 'dataLayer';
	//
	readonly isIdOnlyKey = 'isIdOnly';
	//

	public readonly editRequiredSubLevel = 'ENTERPRISE';

	// Column without prefix
	// tranxCreateColumn = 'tranx_create';
	attrNstdColumn = 'attrs_nstd'; // e.g gad_attrs_nstd
	attrStateColumn = 'attrs_state'; // e.g gad_attrs_state

	// Match point layer columns
	dmStateCodeColumn = 'mpt_state_cd';
	dmGuidColumn = 'mpt_guid';

	nullString = 'NULL';

	public layerInfo: {
		[cateCode: string]: {
			sourceTable: string;
			sourceTableView?: string;
			sourceTableColumns: DataColumn[];
			layerIdCol: string;
			prefix: string;
			// idCols: string[];
		}
	};


	// Edit card
	// public editRecordList: any[] = [];
	// public cardSelectedRecord: BehaviorSubject<CardSelectedRecord> = new BehaviorSubject(null);


	constructor(
		@Inject(DOCUMENT) private document: Document,
		private toastr: ToastrService,
		private activityService: ActivityService,
		private appinfoService: AppinfoService,
		private attrIndexService: AttrIndexService,
		private gtoService: GtoService,
		private qcService: LayerQcService,
		private modalService: CommonModalService,
		private userService: UserService
	) {
		if (!this.layerInfo) {
			this.initLayerInfo();
		}
	}
	private initLayerInfo() {
		this.layerInfo = {};
		this.appinfoService.layerTypeList.forEach(t => {
			const colNames = Object.keys(this.appinfoService.columnMap).filter(c => this.appinfoService.columnMap[c].sourceTab === t.tableName);
			const cols = colNames.map(n => this.appinfoService.columnMap[n]);
			const prefix = cols.length ? cols[0].name.split('_')[0] : '';
			this.layerInfo[t.code] = {
				sourceTable: t.tableName,
				sourceTableColumns: cols,
				layerIdCol: prefix ? prefix + '_' + this.attrIndexService.layerIdColumn : '',
				prefix: prefix
				// idCols: cols.filter(c => c.isPrimeKey).map(c => c.name)
			}
		});
		// const info = {
		// 	ROADCL: {
		// 		table: 'azgiv.roadcenterlines',
		// 		view: null
		// 	},
		// 	ADDPTS: {
		// 		table: 'azgiv.addresses',
		// 		view: null
		// 	}
		// };
		// Object.keys(info).forEach(code => {
		// 	const colNames = Object.keys(this.appinfoService.columnMap).filter(c => this.appinfoService.columnMap[c].sourceTab === info[code].table);
		// 	const cols = colNames.map(n => this.appinfoService.columnMap[n]);
		// 	this.layerInfo[code] = {
		// 		sourceTable: info[code].table,
		// 		sourceTableView: info[code].view,
		// 		sourceTableColumns: cols,
		// 		idCols: cols.filter(c => c.isPrimeKey).map(c => c.name)
		// 	};
		// });
	}

	// public addBackgroundDemarcationLayer(map: LRSMap.Map) {
	// 	map.addLayer(this.dmBackgroundLayerName, {
	// 		style: new Style({
	// 			stroke: new Stroke({
	// 				width: 2,
	// 				color: 'rgba(0, 102, 204)'
	// 			}),
	// 			image: new Circle({
	// 				radius: 3,
	// 				fill: new Fill({
	// 					color: 'gray'
	// 				})
	// 			})
	// 		})
	// 	});
	// }

	public addDataLayer(map: LRSMap.Map) {
		map.addLayer(this.dataLayerName, {
			style: new Style({
				fill: new Fill({
					color: 'rgba(255, 255, 255, 0.6)',
				}),
				stroke: new Stroke({
					color: 'darkblue',
					width: 1,
				}),
				image: new Circle({
					radius: 5,
					fill: new Fill({
						color: 'gray'
					})
				})
			})
		});
	}

	public getDmBackgroundTooltipContent(props) {
		let content =
			`
			<div class="fishbone-tooltip-block">
				<div class="fishbone-tooltip-title"></div>
				<div class="fishbone-tooltip-content">
		`;
		props = props || {};
		Object.keys(props).forEach(p => {
			if (!this.appinfoService.columnMap[p]) {
				return;
			}
			content += `
				<div class="fishbone-tooltip-content-item">
					<label>${this.appinfoService.columnMap[p].heading}: </label>
					<label>${props[p]}</label>
				</div>
			`
		});
		return content + `
				</div>
			</div>
			`
	}

	//
	public getDeletePointsGto(sourceTableName: string, tablePrefix: string, idColName: string, whereClause?: string, ids?: any[]) {
		const tranxCol = tablePrefix + '_' + this.attrIndexService.tranxDeleteColName;
		//
		const gto: Gto = {
			table: sourceTableName, // this.demarcationSourceTableName,
			operation: 'update',
			properties: []
		};
		const currentDate = new Date();
		const dateUpdateCol = tablePrefix + '_' + this.attrIndexService.dateUpdateCol.toLocaleLowerCase()
		if (ids && ids.length) {
			const idCol = this.appinfoService.columnMap[idColName]; // [this.dmIdColumn];
			gto.keycol = idCol.name;
			gto.keytyp = idCol.type;
			gto.keyvals = ids;
			// Add delete prop for EACH id. // If using where instead of keyvals, only one delete prop will do
			ids.forEach(id => {
				const prop: GtoProperty = {};
				// Update TranxDelete column
				this.addGtoProp('<p_session_id>', tranxCol, prop, this.appinfoService.columnMap[tranxCol].type);
				// Auto add dateUpdate field
				this.addGtoProp(currentDate, dateUpdateCol, prop);
				//
				gto.properties.push(prop);
			})
		} else if (whereClause) {
			const prop: GtoProperty = {};
			this.addGtoProp('<p_session_id>', tranxCol, prop, this.appinfoService.columnMap[tranxCol].type);
			// Auto add dateUpdate field
			this.addGtoProp(currentDate, dateUpdateCol, prop);
			gto.properties.push(prop);
		}
		if (whereClause) {
			gto.where = whereClause;
		}
		return gto;
	}
	addJsonbColsToGto(record, jsonbInfo: JsonbInfo, gtoProp: GtoProperty) {
		Object.keys(jsonbInfo).forEach(jsonbCol => {
			const localCols = jsonbInfo[jsonbCol];
			if (localCols.length) {
				const localAttrs = {};
				localCols.forEach(l => localAttrs[l] = record[l]);
				this.addGtoProp(localAttrs, jsonbCol, gtoProp);
			}
		});
	}
	// Do not include geom/id/uid col in attrCols
	public getInsertNewGto(records, attrCols: string[], sourceTableName: string, tablePrefix: string, manualGeomCol: string, jsonbInfo?: JsonbInfo): {
		gto: Gto,
		changedCols: string[]
	} {
		const changedCols: string[] = [];
		const props: GtoProperty[] = [];
		const tranxCreateCol = tablePrefix + '_' + this.attrIndexService.tranxCreateColName;
		const geomCol = tablePrefix + '_' + this.attrIndexService.geomCol;
		const currentDate = new Date();
		records.forEach(r => {
			const prop: GtoProperty = {};
			// Add attribute
			attrCols.forEach(c => {
				// If it's updateDate column, handle it automatically
				if (c.toLocaleLowerCase() === tablePrefix + '_' + this.attrIndexService.dateUpdateCol.toLocaleLowerCase() && !r[c]) {
					this.addGtoProp(currentDate, c, prop);
					return;
				}
				this.addGtoProp(r[c], c, prop);
				if (r[c] && changedCols.indexOf(c) === -1) {
					changedCols.push(c);
				}
			});
			// Add geometry
			this.addGeomGtoProp(r[manualGeomCol], geomCol, prop);
			// Add tranx create
			this.addGtoProp('<p_session_id>', tranxCreateCol, prop);
			// Add jsonb columns
			if (jsonbInfo) {
				this.addJsonbColsToGto(r, jsonbInfo, prop);
			}
			//
			props.push(prop);
		});

		const gto: Gto = {
			table: sourceTableName, // this.demarcationSourceTableName,
			operation: 'insert',
			properties: props
		};
		return {
			gto: gto,
			changedCols: changedCols
		};
	}
	// Include id cols
	public getUpdateGtosByRecordsArchive(cols: string[], records: any[], originalRecords: any[], sourceTableName: string, tablePrefix: string, primKeyColName: string, manualGeomCol: string, jsonbInfo?: JsonbInfo): {
		gtos: Gto[],
		changedCols: string[]
	} {
		const changedColsByName = {};
		//
		const tranxDeleteCol = tablePrefix + '_' + this.attrIndexService.tranxDeleteColName;
		const tranxCreateCol = tablePrefix + '_' + this.attrIndexService.tranxCreateColName;
		const geomCol = tablePrefix + '_' + this.attrIndexService.geomCol;
		const idCol = this.appinfoService.columnMap[primKeyColName]; // this.dmIdColumn
		const ids = [];
		const retireProps: GtoProperty[] = [];
		const insertProps: GtoProperty[] = [];
		const currentDate = new Date();
		records.forEach((r, idx) => {
			ids.push(r[idCol.name]);
			// Retire
			const retireProp: GtoProperty = {};
			this.addGtoProp('<p_session_id>', tranxDeleteCol, retireProp);
			retireProps.push(retireProp);
			// Insert
			const insertProp: GtoProperty = {};
			// Compare geom col
			// const hasGeomChanged = this.hasCoordChanged(r[manualGeomCol], originalRecords[idx][manualGeomCol]);
			const hasGeomChanged = this.hasValueChanged(r[manualGeomCol], originalRecords[idx][manualGeomCol]);
			if (hasGeomChanged) {
				this.addGeomGtoProp(r[manualGeomCol], geomCol, insertProp);
				changedColsByName[geomCol] = true;
			}
			cols.forEach(c => {
				// Do not insert primary key column / tranx delete column // Still need to insert global id col
				if (c === idCol.name || c === tranxDeleteCol) {
					return;
				}
				// If geometry has changed, do not insert geom col since it's handled above
				if (hasGeomChanged && c === geomCol) {
					return;
				}


				// TODO !!!!!!!!!
				// // If it's the resolve column, set it to false if it's multi agency
				// if (c === this.dmResolvedColumn) {
				// 	const agencyList = this.getAgencyListFromStr(r[this.dmAgencyColumn]);
				// 	if (agencyList.length > 1) {
				// 		this.addGtoProp(false, c, null, insertProp);
				// 		return;
				// 	}
				// }






				const hasChanged = this.hasValueChanged(r[c], originalRecords[idx][c])
				if (hasChanged) {
					this.addGtoProp(r[c], c, insertProp);
					changedColsByName[c] = true;
				} else {
					// Handle updateDate column automatically If user doesn't change it on purpose
					if (c.toLocaleLowerCase() === tablePrefix + '_' + this.attrIndexService.dateUpdateCol.toLocaleLowerCase()) {
						this.addGtoProp(currentDate, c, insertProp);
					} else {
						this.addGtoProp(c, c, insertProp, 'field');
					}
				}
			});
			// Jsonb
			// TODO: add channgedColsByName !!!!!!!!
			if (jsonbInfo) {
				const changedJsonbInfo: JsonbInfo = {};
				Object.keys(jsonbInfo).forEach(j => {
					const hasLocalAttrChanged = jsonbInfo[j].find(localCol => this.hasValueChanged(r[localCol], originalRecords[idx][localCol]));
					if (hasLocalAttrChanged) {
						changedJsonbInfo[j] = jsonbInfo[j];
					}
				});
				this.addJsonbColsToGto(r, changedJsonbInfo, insertProp);
			}
			//
			this.addGtoProp('<p_session_id>', tranxCreateCol, insertProp);
			insertProps.push(insertProp);
		});
		const gtoRetire: Gto = {
			table: sourceTableName, // this.demarcationSourceTableName,
			operation: 'update',
			keycol: idCol.name,
			keytyp: idCol.type,
			keyvals: ids,
			properties: retireProps
		};
		const gtoInsert: Gto = {
			table: sourceTableName, // this.demarcationSourceTableName,
			operation: 'insert',
			keycol: idCol.name,
			keytyp: idCol.type,
			keyvals: ids,
			properties: insertProps
		};
		const gtos = [gtoRetire, gtoInsert];
		return {
			gtos: gtos,
			changedCols: Object.keys(changedColsByName)
		};
	}
	public getUpdateGtosByRecords(cols: string[], records: any[], originalRecords: any[], sourceTableName: string, tablePrefix: string, primKeyColName: string, manualGeomCol: string, jsonbInfo?: JsonbInfo): {
		gtos: Gto[],
		changedCols: string[]
	} {
		const changedColsByName = {};
		//
		const tranxDeleteCol = tablePrefix + '_' + this.attrIndexService.tranxDeleteColName;
		const tranxCreateCol = tablePrefix + '_' + this.attrIndexService.tranxCreateColName;
		const geomCol = tablePrefix + '_' + this.attrIndexService.geomCol;
		const idCol = this.appinfoService.columnMap[primKeyColName]; // this.dmIdColumn
		const ids = [];
		const updateProps: GtoProperty[] = [];
		const currentDate = new Date();
		records.forEach((r, idx) => {
			ids.push(r[idCol.name]);
			// Update
			const updateProp: GtoProperty = {};
			// Compare geom col
			// const hasGeomChanged = this.hasCoordChanged(r[manualGeomCol], originalRecords[idx][manualGeomCol]);
			const hasGeomChanged = this.hasValueChanged(r[manualGeomCol], originalRecords[idx][manualGeomCol]);
			if (hasGeomChanged) {
				this.addGeomGtoProp(r[manualGeomCol], geomCol, updateProp);
				changedColsByName[geomCol] = true;
			}
			cols.forEach(c => {
				// Do not insert primary key column / tranx delete column // Still need to insert global id col
				if (c === idCol.name || c === tranxDeleteCol) {
					return;
				}
				// If geometry has changed, do not insert geom col since it's handled above
				if (hasGeomChanged && c === geomCol) {
					return;
				}
				const hasChanged = this.hasValueChanged(r[c], originalRecords[idx][c])
				if (hasChanged) {
					this.addGtoProp(r[c], c, updateProp);
					changedColsByName[c] = true;
				} else {
					// Handle updateDate column automatically If user doesn't change it on purpose
					if (c.toLocaleLowerCase() === tablePrefix + '_' + this.attrIndexService.dateUpdateCol.toLocaleLowerCase()) {
						this.addGtoProp(currentDate, c, updateProp);
					}
				}
			});
			// Jsonb
			if (jsonbInfo) {
				const changedJsonbInfo: JsonbInfo = {};
				Object.keys(jsonbInfo).forEach(j => {
					const hasLocalAttrChanged = jsonbInfo[j].find(localCol => this.hasValueChanged(r[localCol], originalRecords[idx][localCol]));
					if (hasLocalAttrChanged) {
						changedJsonbInfo[j] = jsonbInfo[j];
					}
				});
				this.addJsonbColsToGto(r, changedJsonbInfo, updateProp);
			}
			//
			this.addGtoProp('<p_session_id>', tranxCreateCol, updateProp);
			updateProps.push(updateProp);
		});
		const gtoUpdate: Gto = {
			table: sourceTableName,
			operation: 'update',
			keycol: idCol.name,
			keytyp: idCol.type,
			keyvals: ids,
			properties: updateProps
		};
		const gtos = [gtoUpdate];
		return {
			gtos: gtos,
			changedCols: Object.keys(changedColsByName)
		};
	}
	getUpdatedGto(sourceTableName: string, tablePrefix: string, primKeyColName: string) {
		//
		const tranxDeleteCol = tablePrefix + '_' + this.attrIndexService.tranxDeleteColName;
		const tranxCreateCol = tablePrefix + '_' + this.attrIndexService.tranxCreateColName;
		const geomCol = tablePrefix + '_' + this.attrIndexService.geomCol;
		const idCol = this.appinfoService.columnMap[primKeyColName]; // this.dmIdColumn
		const ids = [];
		const updateProps: GtoProperty[] = [];
		const gtoUpdate: Gto = {
			table: sourceTableName,
			operation: 'update',
			keycol: idCol.name,
			keytyp: idCol.type,
			keyvals: ids,
			properties: updateProps
		};
		const gtos = [gtoUpdate];
		return {
			gtos: gtos,
		};
	}
	addGtoProp(val, col: string, prop?: GtoProperty, colType?: string, isExpression?: boolean): GtoProperty {
		prop = prop || {};
		// if (val === undefined) {
		// 	val = null;
		// }
		if (val === '') {
			val = null;
		}
		prop[col] = {
			type: colType || this.appinfoService.columnMap[col].type,
			value: val
		}
		if (isExpression) {
			prop[col].expression = true;
		}
		return prop;
	}
	addGeomGtoProp(wktString: string, geomCol: string, prop?: GtoProperty): GtoProperty {
		prop = prop || {};
		prop[geomCol] = {
			type: 'geometry',
			value: 'ST_GeomFromText(\'' + wktString + '\', 3857)'
			// value: 'ST_GeomFromText(\'\'' + wktString + '\'\', 3857)'
		}
		return prop;
	}
	// If distinguishNull is true, treat null/undefined as different value
	hasValueChanged(val, originalVal, distinguishNull?: boolean) {
		if (val === originalVal) {
			return false;
		}
		if (!val || !originalVal) {
			if (distinguishNull) {
				return true;
			} else if ((val === null || val === undefined) && (originalVal === null || originalVal === undefined)) {
				return false;
			} else {
				return true;
			}
		}
		// Check date
		if (typeof val.getTime === 'function' && typeof originalVal.getTime === 'function') {
			return val.getTime() !== originalVal.getTime();
		} else if (typeof (val) === 'object') {
			try {
				return JSON.stringify(val) !== JSON.stringify(originalVal);
			} catch (err) {
				console.log(err);
				return true;
			}
		} else {
			return true;
		}
	}
	hasCoordChanged(coord: number[], originalCoord: number[]) {
		if (coord[0] === originalCoord[0] && coord[1] === originalCoord[1]) {
			return false;
		} else {
			return true;
		}
	}
	getWhereClauseFromColumnFilters(filters: ColumnFilter[]) {
		let whereClause = '';
		filters.forEach((f) => {
			whereClause += f.col + ' ';
			let valueClause;
			const generalType = this.appinfoService.findGeneralCol(f.typ);
			switch (generalType) {
				case 'date': valueClause = '\'' + this.convertDateToStr(f.val) + '\''; break;
				case 'numeric': valueClause = f.val; break;
				case 'uuid':
				case 'text':
				default: valueClause = '\'' + f.val + '\''; break; // Handle default as text column
			}
			switch (f.op) {
				case 'contains': whereClause += 'LIKE \'%' + f.val + '%\''; break; // don't use valueClause here
				case 'startswith': whereClause += 'LIKE \'' + f.val + '%\''; break; // don't use valueClause here
				case 'is null': whereClause += 'IS NULL'; break;
				case 'not null': whereClause += 'IS NOT NULL'; break;
				default: whereClause += this.appinfoService.filterOperators[f.op].label + ' ' + valueClause; break;
			}
			whereClause += ' ';
		});
		return whereClause;
	}
	addToWhereClause = (whereClause: string, add: string) => {
		if (whereClause) {
			whereClause += ' and ' + add;
		} else {
			whereClause = add;
		}
		return whereClause;
	}
	getPrimKeyCol(prefix: string) {
		return `${prefix}_${this.attrIndexService.primKeyCol}`;
	}
	// Convert date to yyyymmdd format
	convertDateToStr(date: Date) {
		if (!date) {
			return '';
		}
		if (typeof date === 'string') {
			return date;
		}
		const add0 = (num, digit) => {
			if (digit === 3) {
				if (num < 9) {
					return '00' + num;
				} else if (num < 99) {
					return '0' + num;
				} else {
					return num.toString();
				}
			} else if (digit === 2) {
				if (num < 9) {
					return '0' + num;
				} else {
					return num.toString();
				}
			}
		};
		// Year part
		let str = date.getFullYear().toString();
		const month = add0(date.getUTCMonth() + 1, 2);
		// Month & Date part
		str += month + add0(date.getUTCDate(), 2) + ' ';
		// // Hour part
		// str += add0(date.getUTCHours(), 2) + ':' +
		// 	add0(date.getUTCMinutes(), 2) + ':' +
		// 	add0(date.getUTCSeconds(), 2) + '.' +
		// 	add0(date.getUTCMilliseconds(), 3);
		return str;
	}
	// Batch
	getUpdateGtosBatchArchive(sourceTableName: string, whereClause: string, changedCols: {[col: string]: {val: any; isExpression?: boolean}}, cols: string[], primKeyCol: string, tablePrefix: string) {
		const tranxDeleteCol = tablePrefix + '_' + this.attrIndexService.tranxDeleteColName;
		const tranxCreateCol = tablePrefix + '_' + this.attrIndexService.tranxCreateColName;
		//
		const changedColsByName = {};
		const retireProps: GtoProperty[] = [];
		const insertProps: GtoProperty[] = [];
		// Retire
		const retireProp: GtoProperty = {};
		this.addGtoProp('<p_session_id>', tranxDeleteCol, retireProp);
		retireProps.push(retireProp);
		// Insert
		const insertProp: GtoProperty = {};
		const currentDate = new Date();

		cols.forEach(c => {
			// Do not insert primary key column / tranx delete column // Still need to insert global id col
			if (c === primKeyCol || c === tranxDeleteCol) {
				return;
			}
			//
			const hasChanged = changedCols.hasOwnProperty(c);
			if (hasChanged) {
				this.addGtoProp(changedCols[c].val, c, insertProp, null, changedCols[c].isExpression);
				changedColsByName[c] = true;
			} else {
				// Handle updateDate column automatically If user doesn't change it on purpose
				if (c.toLocaleLowerCase() === tablePrefix + '_' + this.attrIndexService.dateUpdateCol.toLocaleLowerCase()) {
					this.addGtoProp(currentDate, c, insertProp);
				} else {
					this.addGtoProp(c, c, insertProp, 'field');
				}
			}
		});
		
		
		// TODO: Jsonb


		//
		this.addGtoProp('<p_session_id>', tranxCreateCol, insertProp);
		insertProps.push(insertProp);


		const gtoRetire: Gto = {
			table: sourceTableName,
			operation: 'update',
			keycol: primKeyCol,
			where: whereClause,
			properties: retireProps
		};

		// For archive mode insert, replace prefix_tranx_delete with p_session_id
		let whereClauseInsert = whereClause.replace('_tranx_delete IS NULL', '_tranx_delete = \'<p_session_id>\'');

		const gtoInsert: Gto = {
			table: sourceTableName,
			operation: 'insert',
			keycol: primKeyCol,
			where: whereClauseInsert,
			properties: insertProps
		};
		const gtos = [gtoRetire, gtoInsert];
		return {
			gtos: gtos
		};
	}
	getUpdateGtosBatch(sourceTableName: string, whereClause: string, changedCols: {[col: string]: {val: any; isExpression?: boolean}}, cols: string[], primKeyCol: string, tablePrefix: string) {
		const tranxDeleteCol = tablePrefix + '_' + this.attrIndexService.tranxDeleteColName;
		const tranxCreateCol = tablePrefix + '_' + this.attrIndexService.tranxCreateColName;
		//
		const changedColsByName = {};
		const updateProps: GtoProperty[] = [];
		const updateProp: GtoProperty = {};
		const currentDate = new Date();
		cols.forEach(c => {
			// Do not insert primary key column / tranx delete column // Still need to insert global id col
			if (c === primKeyCol || c === tranxDeleteCol) {
				return;
			}
			//
			const hasChanged = changedCols.hasOwnProperty(c);
			if (hasChanged) {
				this.addGtoProp(changedCols[c].val, c, updateProp, null, changedCols[c].isExpression);
				changedColsByName[c] = true;
			} else {
				// Handle updateDate column automatically If user doesn't change it on purpose
				if (c.toLocaleLowerCase() === tablePrefix + '_' + this.attrIndexService.dateUpdateCol.toLocaleLowerCase()) {
					this.addGtoProp(currentDate, c, updateProp);
				}
			}
		});
		this.addGtoProp('<p_session_id>', tranxCreateCol, updateProp);
		updateProps.push(updateProp);
		const gtoUpdate: Gto = {
			table: sourceTableName,
			operation: 'update',
			keycol: primKeyCol,
			where: whereClause,
			properties: updateProps
		};
		const gtos = [gtoUpdate];
		return {
			gtos: gtos
		};
	}

	// #region Clause & Expression
		// For clause operated on numeric field:
		// Replace user-input column name to database column name
		private replaceColInClause(txt: string, colsAll: {name;prop;}[]){
			let isExpression = false;
			// let updatedTxt = txt;
			let handled = '';
			let unhandled = txt;
			const regex = /\[(.*?)\]/;
			let match = unhandled.match(regex);
			let count = 0;
			while (match && count < 100) {
				count++;
				const matchedStr = match[0];
				const matchIdx = match.index;
				let updatedMatchedStr = matchedStr;
				const colName = match[1]; // column name user put
				const col = colsAll.find(c => c.name.toLowerCase() === colName.toLowerCase());
				if (col) {
					isExpression = true;
					updatedMatchedStr = ` ${col.prop} `;
				}
				// Replace txt with updated column
				handled += unhandled.substring(0, matchIdx) + updatedMatchedStr;
				unhandled = unhandled.substring(matchIdx + matchedStr.length);
					// updatedTxt = updatedTxt.substring(0, matchIdx - 1) + updatedMatchedStr + updatedTxt.substring(matchIdx + matchedStr.length);
				// Re-calculate match
				match = unhandled.match(regex);
			}
			if (unhandled) {
				handled += unhandled;
			}
			return {
				txt: handled,
				isExpression: isExpression
			};
		}
		// For clause operated on text field
		// 1. If [column] is followed by +, replace + with ||, and add quotes to the string after it
		// 2. Replace column name to database column name, and remove []
		private replaceColAndValueInClause(txt: string, colsAll: {name;prop;}[]) {
			let isExpression = false;
			// First: Find [column] followed by +, handle the value
			const regex = /\[(.*?)\]\s?\+.*?(?=((\[(.*?)\]))|$)/;
			// const regex = /\[(.*?)\]\s?\+.*?(?=(\[(.*?)\]))/;
			let handled = '';
			let unhandled = txt;
			let match = unhandled.match(regex);
			let count = 0;
			while (match && count < 100) {
				count++;
				const matchedStr = match[0];
				const matchIdx = match.index;
				let updatedMatchedStr = '';
				// Part 1: [column] +
				const regexColumn = /\[(.*?)\]?(?=(\s?\+.*))/; // match [column] (exclude + from match result)
				const matchedColumn = matchedStr.match(regexColumn);
				const colName = matchedColumn[1]; // column name user put
				const col = colsAll.find(c => c.name.toLowerCase() === colName.toLowerCase());
				if (col) {
					isExpression = true;
					// Part 1: remove [] from [column], replace + with ||
					updatedMatchedStr = ` ${col.prop} || `;
					const regexColumnAndOperator = /\[(.*?)\]\s?\+/;
					const matchedPart1 = matchedStr.match(regexColumnAndOperator);
					const part1 = matchedPart1[0];
					const part1Index = matchedPart1.index;
					// Part 2 is the value, wrap it within 2 single quotes
					let part2 = matchedStr.substring(part1Index + part1.length).trim();
					if (part2) {
						updatedMatchedStr += '\'\'' + part2 + '\'\'';
					}
				} else {
					updatedMatchedStr = matchedStr;
				}

				// Replace txt with updated column
				handled += unhandled.substring(0, matchIdx) + updatedMatchedStr;
				unhandled = unhandled.substring(matchIdx + matchedStr.length);
					// updatedTxt = updatedTxt.substring(0, matchIdx - 1) + updatedMatchedStr + updatedTxt.substring(matchIdx + matchedStr.length);
				// Re-calculate match
				match = unhandled.match(regex);
			}
			if (unhandled) {
				handled += unhandled;
			}

			// Second: check for all [user column] left, and replace it to [database column]
			const check2 = this.replaceColInClause(handled, colsAll);
			handled = check2.txt;
			if (check2.isExpression && !isExpression) {
				isExpression = true;
			}

			return {
				txt: handled,
				isExpression: isExpression
			};
		}
		// checkClauseVal: 1. check if clause need field calculate
		// 2. format some of the values
		// 3. check validity, but for fieldCalc, the validity will be check somewhere else
		checkClauseVal(clauseVal, col: {prop;type:GeneralColType}, domainsByColumn: {[prop: string]: GivColumnDomain;}) {
			let val;
			let isFieldCalc = false;
			let isValid: boolean;
			// Check 'Null'
			if (typeof(clauseVal) === 'string' && clauseVal.trim().toLowerCase() === 'null') {
				val = this.nullString;
				isFieldCalc = false;
				isValid = true;
				// TODO: nullable
				// if (clause.col.nullable) {
				// 	clause.isValid = true;
				// } else {
				// 	clause.isValid = false;
				// }
			} else if (col && clauseVal && typeof(clauseVal) === 'string' && clauseVal.indexOf('[') > -1) {
				val = clauseVal;
				// val = clauseVal.replace(/\[/g, '');
				// val = val.replace(/\]/g, '');
				isFieldCalc = true;
			} else {
				isValid = true;
				if (col.type === 'text') {
					val = '\'' + clauseVal + '\'';
				} else {
					if (col.type === 'numeric') {
						val = Number(clauseVal);
						if (isNaN(val)) {
							isValid = false;
							this.toastr.warning('Invalid expression');
						} else {
							const domain = domainsByColumn[col.prop];
							if (domain && domain.type === 'range') {
								if (val < domain.range[0] || val > domain.range[1]) {
									isValid = false;
									this.toastr.warning('The Value is out of range ' + domain.range[0] + ' - ' + domain.range[1]);
								}
							}
						}
					} else {
						val = clauseVal;
					}
					// TODO
				}
			}
			return {
				isFieldCalc: isFieldCalc,
				isValid: isValid,
				val: val
			}
		}
		formatClauseValForGto(clauseVal, colType: GeneralColType, colsAll: {name;prop;}[]) {
			let val;
			let isExpression: boolean;
			if (typeof(clauseVal) !== 'string') {
				val = clauseVal;
			} else {
				// For string clauseVal, it could be expression
				if (colType === 'numeric') {
					// Replace column in [] to real column name
					const replace = this.replaceColInClause(clauseVal, colsAll);
					val = replace.txt;
					if (replace.isExpression) {
						isExpression = true;
					}
				} else if (colType === 'text') {
					// Check if [column] is followed by +, if so, replace + with ||, and add quotes to the string after it
					let replace = this.replaceColAndValueInClause(clauseVal, colsAll);
					val = replace.txt;
					if (replace.isExpression) {
						isExpression = true;
					}
				} else {
					val = clauseVal;
				}
			}
			return {
				val: val,
				isExpression: isExpression
			};
		}
	// #endregion

	// For both Batch & Domain Reco Center. // Commit gtos -> Run dynamic qc -> Run (or not) qcLayers
	async commitGtoAndQcForBach(gtos: Gto[], changedCols: string[], layerId, prefix: string) {
		console.log(gtos);
		try {
			const rsp = await this.gtoService.processGto(gtos);
			const tranxId = rsp.sessionId; // rsp.data.content;
			this.toastr.success('Successfully updated.');
			// 
			let tranxIdWhere = `${prefix}_${this.attrIndexService.tranxCreateColName} = '${tranxId}'`;
			tranxIdWhere = this.addToWhereClause(tranxIdWhere, `${prefix}_${this.attrIndexService.layerIdColumn} = ${layerId}`);

			let editFiltersWhereClause = tranxIdWhere;
			const editFilters: QcEditFilter[] = [{
				gly_id: layerId,
				cols: changedCols,
				where: editFiltersWhereClause
			}];
			const qcRsp = await this.qcService.qcLayersDynamic(editFilters);
			if (qcRsp.misc && qcRsp.misc.transition > 0) {
				this.qcService.qcLayers([layerId]);
			}
			// else {
				this.activityService.refreshData.next({
					updateLayerList: true,
					updateSchema: true
				});
			// }
		} catch (err) {
			this.toastr.error('Failed to update.')
			console.log(err);
		}
	}

	// Get all cols in source table without system cols
	getUpdateColsInSourceTable(sourceTableName: string, prefix: string) {
		const colsAll: string[] = Object.keys(this.appinfoService.columnMap).filter(c => this.appinfoService.columnMap[c].sourceTab === sourceTableName);
		// Remove system cols
		const primKeyCol = this.getPrimKeyCol(prefix);
		const systemCol_id_idx = colsAll.findIndex(c => c === primKeyCol);
		colsAll.splice(systemCol_id_idx, 1);
		return colsAll;
	}

	async warnOnLeave() {
		const options: MatDialogConfig = {
			width: '600px'
		}
		const rsp: LeaveWarningResponse = await this.modalService.openModalWindow(UnsavedChangesWarningComponent, options);
		return rsp;
	}
	async warnOnDiscard() {
		const options: MatDialogConfig = this.modalService.confirmModalOptions;
		const data: ConfirmModalData = {
			message: 'Are you sure to discard the changes?'
		}
		options.data = data;
		const rsp = await this.modalService.openModalWindow(ConfirmModalComponent, options);
		return rsp;
	}

	checkEditModeDisabled() {
		if (this.userService.userSubscription.subLevel !== this.editRequiredSubLevel) {
			return `Subscription level not ${this.editRequiredSubLevel}`;
		}
		if (this.userService.customerInfo.type === 'end-user' && this.userService.customerInfo.id !== this.userService.selectedCustomer.getValue().id) {
			return 'Selected agency not match';
		}
	}


	// Trigger
	editTrigger(cateCode, rec, changedCol: string, changedVal) {
		const triggerChanges: {
			[prop: string]: any
		} = {};
		if (cateCode === 'ROADCL') {
			switch (changedCol) {
				case this.attrIndexService.rdLstTypeColName:
				case this.attrIndexService.rdPostTypeColName:
					const stTypeMap = this.appinfoService.nagPostypeCrosswalk[changedVal];
					if (stTypeMap) {
						if (changedVal === stTypeMap.nena) {
							triggerChanges[this.attrIndexService.rdLstTypeColName] = stTypeMap.usps;
						} else if (changedVal === stTypeMap.usps) {
							triggerChanges[this.attrIndexService.rdPostTypeColName] = stTypeMap.nena;
						}
					}
					break;
				case this.attrIndexService.rdPredirColName:
				case this.attrIndexService.rdLstPredirColName:
				case this.attrIndexService.rdPosdirColName:
				case this.attrIndexService.rdLstPosdirColName:
					const dirMap = this.appinfoService.nagDirectionCrosswalk[changedVal];
					switch (changedCol) {
						case this.attrIndexService.rdPredirColName:
							triggerChanges[this.attrIndexService.rdLstPredirColName] = dirMap.usps;
							break;
						case this.attrIndexService.rdLstPredirColName:
							triggerChanges[this.attrIndexService.rdPredirColName] = dirMap.nena;
							break;
						case this.attrIndexService.rdPosdirColName:
							triggerChanges[this.attrIndexService.rdLstPosdirColName] = dirMap.usps;
							break;
						case this.attrIndexService.rdLstPosdirColName:
							triggerChanges[this.attrIndexService.rdPosdirColName] = dirMap.nena;
							break;
					}
					break;
				case this.attrIndexService.rdPreTypeColName:
				case this.attrIndexService.rdPresepColName:
				case this.attrIndexService.rdStreetNameColName:
					let lstName = '';
					const add = (prop) => {
						if (rec[prop]) {
							lstName += rec[prop] + ' ';
						}
					}
					add(this.attrIndexService.rdPreTypeColName);
					add(this.attrIndexService.rdPresepColName);
					add(this.attrIndexService.rdStreetNameColName);
					lstName = lstName.trim();
					triggerChanges[this.attrIndexService.rdLstNameColName] = lstName;
					break;
			}
		}
		return triggerChanges;
	}

}
